if (!customElements.get("td-blog-tags-menu")) {
    class TdBlogTagsMenu extends HTMLElement {
      constructor() {
        super();  
        this.links = Array.from(this.querySelectorAll('a'))
        
        const pathname = window.location.pathname
        const origin =  window.location.origin
        
        this.links.map((link) => {
           const link_url = link.href.replace(origin,'')
        
           if(link_url == pathname) {
            
            link.classList.add('active')
           }
        })
      
      }
    }
    
    customElements.define("td-blog-tags-menu", TdBlogTagsMenu);
  }
  